import styled from 'styled-components';

export const StyledSuccessMessage = styled.div`
  margin-bottom: 2rem;
  font-size: 1rem;
`;
